<template>
  <b-row>
    <b-col lg="12">
      <div
        id="container"
        class="d-flex justify-content-end"
      >
        <svg
          :width="isSmallScreen() ? '100%' : '580px'"
          :height="isSmallScreen() ? '100%' : '100%'"
          viewBox="0 0 713 950"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_df_368_286)">
            <path
              id="svg3"
              d="M355.361 9.00868L697.7 9.00867"
              stroke="url(#paint0_linear_368_286)"
              stroke-width="10"
              stroke-linecap="round"
              style="mix-blend-mode:difference"
              shape-rendering="crispEdges"
            />
          </g>
          <path
            d="M26.7719 244L673.789 243.405H687.162H711V215.23V109.318V100.149V17H649.764H349.15H292.382H39.4662H4V50.645V213.658V244H26.7719Z"
            fill="#000e10"
            fill-opacity="0.5"
          />
          <path
            d="M26.7719 535L673.789 534.256H687.162H711V499.006V366.499V355.028V251H649.764H349.15H292.382H39.4662H4V293.093V497.039V535H26.7719Z"
            fill="#000e10"
            fill-opacity="0.5"
          />
          <path
            d="M24.8363 947L673.684 945.936H687.095H711V895.543V706.114V689.716V541H649.591H348.126H291.197H37.5665H2V601.176V892.732V947H24.8363Z"
            fill="#000e10"
            fill-opacity="0.5"
          />
          <!-- <defs>
            <filter
              id="filter0_df_368_286"
              x="346.361"
              y="0.00866699"
              width="360.339"
              height="22"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood
                flood-opacity="0"
                result="BackgroundImageFix"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="out"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_368_286"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_368_286"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="2"
                result="effect2_foregroundBlur_368_286"
              />
            </filter>
            <linearGradient
              id="paint0_linear_368_286"
              x1="503.064"
              y1="198.393"
              x2="503.064"
              y2="-190.503"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0.472232"
                stop-color="#01557B"
              />
              <stop
                offset="0.48"
                stop-color="#00E7FF"
              />
              <stop
                offset="0.501795"
                stop-color="#01557B"
              />
            </linearGradient>
          </defs> -->

          <!-- ปริมาณจราจรแต่ละ Phase (วัน) -->
          <foreignObject
            width="82%"
            height="100%"
            x="15"
            y="10"
          >
            <div>
              <svg
                width="1143"
                height="154"
                viewBox="0 0 1143 154"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.2">
                  <path
                    d="M507.159 118.184H623.083H1111V23H32L33.7942 95.7745V118.184H507.159Z"
                    fill="url(#paint0_linear_26_2)"
                    fill-opacity="0.5"
                  />
                </g>
                <g filter="url(#filter0_d_26_2)">
                  <path
                    d="M1108 123.184C1110.76 123.184 1113 120.945 1113 118.184C1113 115.422 1110.76 113.184 1108 113.184V123.184ZM30 123.184H1108V113.184H30V123.184Z"
                    fill="url(#paint1_linear_26_2)"
                  />
                </g>
                <g
                  id="bolt1"
                  filter="url(#filter1_df_26_2)"
                >
                  <path
                    d="M37.9988 25.7111C37.9408 22.9502 35.6557 20.7592 32.8949 20.8172C30.1341 20.8752 27.943 23.1603 28.001 25.9211L37.9988 25.7111ZM28.001 25.9211L30.0011 121.105L39.9989 120.895L37.9988 25.7111L28.001 25.9211Z"
                    fill="#00E7FF"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_26_2"
                    x="0"
                    y="83.1839"
                    width="1143"
                    height="70"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="15" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.183437 0 0 0 0 0.340519 0 0 0 0 0.375 0 0 0 0.49 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                  </filter>
                  <filter
                    id="filter1_df_26_2"
                    x="7.99991"
                    y="0.816069"
                    width="51.999"
                    height="140.289"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="2.5"
                      result="effect2_foregroundBlur_26_2"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_26_2"
                    x1="1111.03"
                    y1="105.071"
                    x2="33.79"
                    y2="105.071"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop />
                    <stop
                      offset="0.0810585"
                      stop-color="#000506"
                    />
                    <stop
                      offset="0.1876"
                      stop-color="#001416"
                    />
                    <stop
                      offset="0.3084"
                      stop-color="#205274"
                    />
                    <stop
                      offset="0.4397"
                      stop-color="#27628A"
                    />
                    <stop
                      offset="0.5795"
                      stop-color="#3585BB"
                    />
                    <stop
                      offset="0.724"
                      stop-color="#00A0C3"
                    />
                    <stop
                      offset="0.8554"
                      stop-color="#00B3FF"
                    />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_26_2"
                    x1="30"
                    y1="118.684"
                    x2="1108"
                    y2="118.684"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#0D6E89" />
                    <stop
                      offset="0.421"
                      stop-color="#2A929C"
                      stop-opacity="0.5"
                    />
                    <stop
                      offset="0.681"
                      stop-color="#1C6269"
                      stop-opacity="0.2"
                    />
                    <stop
                      offset="1"
                      stop-color="#2F5760"
                      stop-opacity="0.15"
                    />
                  </linearGradient>
                </defs>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="80"
                  y="40"
                >
                  <span style="font-size: 38px;">เวลาปล่อยสัญญาณไฟเขียว ณ ปัจจุบัน</span>
                </foreignObject>
              </svg>
            </div>
          </foreignObject>

          <!-- TrafficSciFiGaugePhase -->
          <foreignObject
            id="bolt1"
            width="100%"
            height="100%"
            x="0"
            y="40"
          >
            <div>
              <TrafficSciFiGaugePhase />
            </div>
          </foreignObject>

          <!-- กราฟ Modal Phase -->
          <foreignObject
            width="100%"
            height="100%"
            x="670"
            y="40"
          >
            <div>
              <feather-icon
                v-b-modal="'ModalPhase2'"
                :style="{ color: 'rgb(41, 213, 255)' }"
                icon="ActivityIcon"
                size="22"
              />
            </div>
            <ModalPhase2
              ref=""
            />
          </foreignObject>

          <!-- TrafficSciFiRightPhase 3 -->
          <foreignObject
            id="bolt1"
            width="100%"
            height="100%"
            x="65"
            y="200"
          >
            <div>
              <TrafficSciFiRightPhase3 />
            </div>
          </foreignObject>

          <foreignObject
            width="82%"
            height="100%"
            x="15"
            y="255"
          >
            <div>
              <svg
                width="1143"
                height="154"
                viewBox="0 0 1143 154"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.2">
                  <path
                    d="M507.159 118.184H623.083H1111V23H32L33.7942 95.7745V118.184H507.159Z"
                    fill="url(#paint0_linear_26_2)"
                    fill-opacity="0.5"
                  />
                </g>
                <g filter="url(#filter0_d_26_2)">
                  <path
                    d="M1108 123.184C1110.76 123.184 1113 120.945 1113 118.184C1113 115.422 1110.76 113.184 1108 113.184V123.184ZM30 123.184H1108V113.184H30V123.184Z"
                    fill="url(#paint1_linear_26_2)"
                  />
                </g>
                <g
                  id="bolt1"
                  filter="url(#filter1_df_26_2)"
                >
                  <path
                    d="M37.9988 25.7111C37.9408 22.9502 35.6557 20.7592 32.8949 20.8172C30.1341 20.8752 27.943 23.1603 28.001 25.9211L37.9988 25.7111ZM28.001 25.9211L30.0011 121.105L39.9989 120.895L37.9988 25.7111L28.001 25.9211Z"
                    fill="#00E7FF"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_26_2"
                    x="0"
                    y="83.1839"
                    width="1143"
                    height="70"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="15" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.183437 0 0 0 0 0.340519 0 0 0 0 0.375 0 0 0 0.49 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                  </filter>
                  <filter
                    id="filter1_df_26_2"
                    x="7.99991"
                    y="0.816069"
                    width="51.999"
                    height="140.289"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="2.5"
                      result="effect2_foregroundBlur_26_2"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_26_2"
                    x1="1111.03"
                    y1="105.071"
                    x2="33.79"
                    y2="105.071"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop />
                    <stop
                      offset="0.0810585"
                      stop-color="#000506"
                    />
                    <stop
                      offset="0.1876"
                      stop-color="#001416"
                    />
                    <stop
                      offset="0.3084"
                      stop-color="#205274"
                    />
                    <stop
                      offset="0.4397"
                      stop-color="#27628A"
                    />
                    <stop
                      offset="0.5795"
                      stop-color="#3585BB"
                    />
                    <stop
                      offset="0.724"
                      stop-color="#00A0C3"
                    />
                    <stop
                      offset="0.8554"
                      stop-color="#00B3FF"
                    />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_26_2"
                    x1="30"
                    y1="118.684"
                    x2="1108"
                    y2="118.684"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#0D6E89" />
                    <stop
                      offset="0.421"
                      stop-color="#2A929C"
                      stop-opacity="0.5"
                    />
                    <stop
                      offset="0.681"
                      stop-color="#1C6269"
                      stop-opacity="0.2"
                    />
                    <stop
                      offset="1"
                      stop-color="#2F5760"
                      stop-opacity="0.15"
                    />
                  </linearGradient>
                </defs>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="80"
                  y="40"
                >
                  <span style="font-size: 35px;">ปริมาณจราจร PCU 7 วัน (แยกตาม Phase)</span>
                </foreignObject>
              </svg>
            </div>
          </foreignObject>

          <foreignObject
            id=""
            width="100%"
            height="100%"
            x="5"
            y="305"
          >
            <div id="boltX1">
              <TrafficBarChart />
            </div>
          </foreignObject>

          <!-- <foreignObject
            width="22%"
            height="22%"
            x="262"
            y="541"
          >
            <div>
              <svg
                id="circle1"
                viewBox="0 0 28 28"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="14"
                  cy="14"
                  r="11.5"
                  stroke="url(#paint0_linear_270_4228)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_270_4228"
                    x1="6.21496"
                    y1="-2.22036e-09"
                    x2="21.785"
                    y2="28"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#1D93A4" />
                    <stop
                      offset="0.511"
                      stop-color="rgba(12, 247, 240, 1)"
                    />
                    <stop
                      offset="1"
                      stop-color="#1D93A4"
                    />
                  </linearGradient>
                </defs>
              </svg>

            </div>
          </foreignObject> -->

          <!-- <foreignObject
            width="100%"
            height="100%"
            x="-16"
            y="420"
          >
            <div id="boltX2">
              <TrafficSciFiPie />
            </div>
          </foreignObject> -->

          <foreignObject
            width="82%"
            height="100%"
            x="15"
            y="550"
          >
            <div>
              <svg
                width="1143"
                height="154"
                viewBox="0 0 1143 154"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.2">
                  <path
                    d="M507.159 118.184H623.083H1111V23H32L33.7942 95.7745V118.184H507.159Z"
                    fill="url(#paint0_linear_26_2)"
                    fill-opacity="0.5"
                  />
                </g>
                <g filter="url(#filter0_d_26_2)">
                  <path
                    d="M1108 123.184C1110.76 123.184 1113 120.945 1113 118.184C1113 115.422 1110.76 113.184 1108 113.184V123.184ZM30 123.184H1108V113.184H30V123.184Z"
                    fill="url(#paint1_linear_26_2)"
                  />
                </g>
                <g
                  id="bolt1"
                  filter="url(#filter1_df_26_2)"
                >
                  <path
                    d="M37.9988 25.7111C37.9408 22.9502 35.6557 20.7592 32.8949 20.8172C30.1341 20.8752 27.943 23.1603 28.001 25.9211L37.9988 25.7111ZM28.001 25.9211L30.0011 121.105L39.9989 120.895L37.9988 25.7111L28.001 25.9211Z"
                    fill="#00E7FF"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_26_2"
                    x="0"
                    y="83.1839"
                    width="1143"
                    height="70"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="15" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.183437 0 0 0 0 0.340519 0 0 0 0 0.375 0 0 0 0.49 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                  </filter>
                  <filter
                    id="filter1_df_26_2"
                    x="7.99991"
                    y="0.816069"
                    width="51.999"
                    height="140.289"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_26_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_26_2"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="2.5"
                      result="effect2_foregroundBlur_26_2"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_26_2"
                    x1="1111.03"
                    y1="105.071"
                    x2="33.79"
                    y2="105.071"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop />
                    <stop
                      offset="0.0810585"
                      stop-color="#000506"
                    />
                    <stop
                      offset="0.1876"
                      stop-color="#001416"
                    />
                    <stop
                      offset="0.3084"
                      stop-color="#205274"
                    />
                    <stop
                      offset="0.4397"
                      stop-color="#27628A"
                    />
                    <stop
                      offset="0.5795"
                      stop-color="#3585BB"
                    />
                    <stop
                      offset="0.724"
                      stop-color="#00A0C3"
                    />
                    <stop
                      offset="0.8554"
                      stop-color="#00B3FF"
                    />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_26_2"
                    x1="30"
                    y1="118.684"
                    x2="1108"
                    y2="118.684"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#0D6E89" />
                    <stop
                      offset="0.421"
                      stop-color="#2A929C"
                      stop-opacity="0.5"
                    />
                    <stop
                      offset="0.681"
                      stop-color="#1C6269"
                      stop-opacity="0.2"
                    />
                    <stop
                      offset="1"
                      stop-color="#2F5760"
                      stop-opacity="0.15"
                    />
                  </linearGradient>
                </defs>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="80"
                  y="40"
                >
                  <span style="font-size: 35px;">สัดส่วนเวลาในการปล่อยไฟรายชั่วโมง (วันนี้)</span>
                </foreignObject>
              </svg>
            </div>
          </foreignObject>

          <foreignObject
            width="100%"
            height="100%"
            x="-16"
            y="515"
          >
            <div>
              <TrafficGraphLine />
            </div>
          </foreignObject>
        </svg>

      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import TrafficBarChart from '@/views/traffiscifi/detailfi/TrafficBarChart.vue'
// import TrafficSciPhase from '@/views/traffiscifi/detailfi/TrafficSciPhase.vue'
import ModalPhase2 from '@/views/traffiscifi/detailfi2/ModalGraphPhase.vue'
// import TrafficSciFiPie from '@/views/traffiscifi/detailfi2/TrafficPie.vue'
import TrafficSciFiRightPhase3 from '@/views/traffiscifi/detailfi2/TrafficSciFiRightPhase3.vue'
import TrafficSciFiGaugePhase from '@/views/traffiscifi/detailfi2/TrafficSciFiGaugePhase.vue'
import TrafficGraphLine from '@/views/traffiscifi/detailfi2/TrafficGraphLine.vue'

export default {
  // name: 'SVGAnimation',
  components: {
    BRow,
    BCol,

    TrafficBarChart,
    TrafficGraphLine,
    // TrafficSciPhase,
    TrafficSciFiRightPhase3,
    TrafficSciFiGaugePhase,
    // TrafficSciFiPie,
    ModalPhase2,
  },
  data() {
    return {
      // animate: false,
    }
  },
  computed: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isSmallScreen)
  },
  mounted() {
    window.addEventListener('resize', this.isSmallScreen)
    this.interval = setInterval(() => {
      window.addEventListener('resize', this.isSmallScreen)
    }, 100000)
  },
  methods: {
    // toggleAnimation() {
    //   this.animate = !this.animate
    // },
    isSmallScreen() {
      return window.innerWidth <= 850
    },
  },
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

#container {
  // height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
svg {
  max-width: 100%;
  height: auto;
  background: none; /* Ensures no background color */
  fill: rgba(0, 7, 33, 0.573); /* Prevents fill patterns from having unwanted backgrounds */
}

#svg3 {
  justify-content: center;
  align-items: center;

  // --grey: rgb(255, 87, 51, 1.0);
  --magenta: url(#paint0_linear_368_286);

  // width: 150px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 400;
  stroke-dashoffset: 54;
  stroke-linejoin: round;
  stroke-linecap: round;
  transform-origin: center;
  animation: 2s ease-in-out infinite fadeStrokeright1;
  // stroke: rgb(48, 181, 235);

@keyframes fadeStrokeright1 {
    0%, 100% {
      stroke-width: 8;
    }
    60% {
      stroke-width: 12;
    }
    // 100% {
    //   stroke-width: 8;
    // }
    20% {
      stroke-width: 6;
    }
  }
}

#bolt1 {
   animation: dropInY1 6s ease forwards;
   animation-delay: 200ms;

   @keyframes dropInY1 {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    30%, 100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
#boltX1 {
   animation: dropInX1 10s ease forwards;
   animation-delay: 200ms;

   @keyframes dropInX1 {
    0% {
      opacity: 0;
      transform: translateZ(-100%);
    }
    100% {
      opacity: 1;
      transform: translateZ(0);
    }
  }
}

#circle1 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: rgb(0, 204, 255);

  width: 200px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 16, 10;
  stroke-dashoffset: 52;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 3s ease-in infinite likecircle1,
  // 0.8s linear 2s 2 forwards beat,
  3s ease-in-out infinite fadeStrokecircle1;
  // stroke: rgb(255, 87, 51);

  @keyframes likecircle1 {
  0% {
    stroke-dashoffset: 52;
    fill: var(--grey);
  }

  70% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    // opacity: 0;
    fill: rgba(0, 176, 182, 0.0)
  }
}

@keyframes fadeStrokecircle1 {
    0%, 100% {
      stroke-width: 1;
    }
    50% {
      stroke-width: 0;
    }
  }
}

#circle2 {
  justify-content: center;
  align-items: center;

  --grey: rgb(255, 87, 51, 0.0);
  --magenta: rgb(0, 204, 255);

  width: 110px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 2, 6;
  stroke-dashoffset: 56;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: 10s linear infinite likecircle2;

  @keyframes likecircle2 {
  0% {
    stroke-dashoffset: 56;
    fill: var(--grey);
  }

  100% {
    stroke-dashoffset: 0;
    fill: var(--grey);
  }

  // 100% {
  //   stroke-dashoffset: 0;
  //   // opacity: 0;
  //   fill: rgba(0, 176, 182, 0.0)
  // }
}
}
</style>
